import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar/AppBar';

export const StyledAppBar = styled(AppBar)`
  && {
    background-color: transparent;
    box-shadow: none;
  }
`;
